import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { createJSONStorage, persist } from 'zustand/middleware';
import { ClientId } from '@nexelem/config';

type DevtoolsStoreState = {
  clientId?: ClientId;
};

type DevtoolsStoreStateFn = {
  setClient: (clientId: ClientId) => void;
  getProperty: <P>(property: keyof DevtoolsStoreState, defaultValue: P) => P;
};

export const showDevtools = process.env.NODE_ENV === 'development' || localStorage?.getItem('nexelem-devtools');

export const useDevtoolsStore = create(
  persist(
    immer<DevtoolsStoreState & DevtoolsStoreStateFn>((set, get) => {
      return {
        setClient: (clientId) => {
          set((state) => {
            state.clientId = clientId;
          });
        },
        getProperty: (property, defaultValue) => {
          if (defaultValue === undefined || defaultValue === null) {
            return defaultValue;
          }

          if (!showDevtools) {
            return defaultValue;
          }

          return (get()[property] as typeof defaultValue) || defaultValue;
        },
      };
    }),
    {
      name: `mocks-store-${process.env.NODE_ENV}`,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
